import React, {Component} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"

class Text extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  _handleChange(e) {
    const {question, onChange} = this.props

    // uuids must be prefixed with "question_"
    onChange({
      [`question_${question.id}`]: e.currentTarget.value
    })
  }

  render() {
    const {question, t} = this.props

    return (
      <div className="text" key={`text-${question.id}`}>
        <textarea
          placeholder={t("Deine Nachricht...")}
          onChange={e => this._handleChange(e)}
        />
      </div>
    )
  }
}

export default translate()(Text)



// WEBPACK FOOTER //
// ./src/components/Feedback/Text/index.js